import useCurrentResult from '../../hooks/useCurrentResult';
import useSelectedPinCategory from '../../hooks/useSelectedPinCategory';
import SelectedPin from '../SelectedPin';
import TrailheadMarker from '../TrailheadMarker';

const BasePins = () => {
  const currentResult = useCurrentResult();
  const selectedPinCategory = useSelectedPinCategory({});

  return (
    <>
      {selectedPinCategory === 'trailhead' && <TrailheadMarker currentResult={currentResult} />}
      {selectedPinCategory === 'standard' && <SelectedPin result={currentResult} />}
    </>
  );
};

export default BasePins;
